<template>
    <el-aside
        :class="{
            expanded: isVisible,
            'sidebar-container': true,
        }"
    >
        <div class="h-100 position-relative">
            <!-- BEGIN OF IMAGE AND AVATAR COMPONENT -->
            <el-row :gutter="32" class="header-wrapper">
                <el-col>
                    <img class="logo-con" src="/static/vrs-white.svg" />
                </el-col>
                <el-col class="seperator" />
                <el-col align="center">
                    <img
                        class="avatar"
                        :src="user.photoPath"
                        onerror="this.src = '/static/user.svg'"
                        width="36"
                        height="36"
                    />
                    <el-row type="flex" justify="center" align="middle">
                        <div class="my-5px user-name" @click="onProfileClick">
                            {{ user.fullName }}
                        </div>
                        <notifications></notifications>
                    </el-row>
                </el-col>
            </el-row>
            <!-- END OF IMAGE AND AVATAR COMPONENT -->
            <div :class="{ expanded: isVisible, sidenav: true }">
                <el-scrollbar :class="isRtl ? 'scrollbar-rtl' : ''">
                    <el-menu
                        :default-active="$route.path"
                        :class="['sidenav-menu']"
                        :router="true"
                        ref="nav"
                        unique-opened
                        @select="handleMenuSelect"
                    >
                        <el-menu-item
                            index="/dashboard"
                            v-if="context.canRead('survey_management_dashboard')"
                        >
                            <i class="fa fa-dashboard"></i>
                            <span slot="title">{{ $t('Dashboard') }}</span>
                        </el-menu-item>
                        <el-menu-item
                            index="/feeds"
                            v-if="context.canRead('survey_management_feeds')"
                        >
                            <i class="fa fa-rss"></i>
                            <span slot="title">{{ $t('Survey Management') }}</span>
                        </el-menu-item>
                        <el-menu-item
                            index="/clients"
                            v-if="
                                context.canRead('customer_management_customer') &&
                                contextOrganization.org_tag !== 'damage-notice'
                            "
                        >
                            <i class="fa fa-id-card"></i>
                            <span slot="title">{{ $t('Clients') }}</span>
                        </el-menu-item>
                        <el-menu-item index="/policies" v-if="context.canRead('policy')">
                            <i class="fa fa-id-card"></i>
                            <span slot="title">{{ $t('Policies') }}</span>
                        </el-menu-item>
                        <el-menu-item
                            index="/representatives"
                            v-if="context.canRead('agent_management_agent')"
                        >
                            <i class="fa fa-users"></i>
                            <span slot="title">{{ $t('Risk Engineers') }}</span>
                        </el-menu-item>
                        <el-menu-item
                            index="/organizations"
                            v-if="context.canRead('organization_management_organization')"
                        >
                            <i class="fa fa-sitemap"></i>
                            <span slot="title">{{ $t('Organizations') }}</span>
                        </el-menu-item>
                        <el-menu-item
                            index="/users"
                            v-if="context.canRead('organization_management_user')"
                        >
                            <i class="fa fa-male"></i>
                            <span slot="title">{{ $t('Organization Users') }}</span>
                        </el-menu-item>
                        <el-menu-item
                            index="/roles"
                            v-if="isContextUserRootAdmin && context.canRead('role_management_role')"
                        >
                            <i class="fa fa-male"></i>
                            <span slot="title">{{ $t('Role Management') }}</span>
                        </el-menu-item>
                        <el-submenu
                            index="1"
                            v-if="
                                (isContextUserRootAdmin || contextOrganization.is_micro) &&
                                context.canRead('customer_management_micro_list')
                            "
                        >
                            <template slot="title">
                                <i class="fa fa-compress"></i>
                                <span>{{
                                    $t(isDamageNotice ? 'Damage Management' : 'Micro Management')
                                }}</span>
                            </template>
                            <el-menu-item
                                index="/micro-clients"
                                v-if="context.canRead('customer_management_customer')"
                            >
                                <i class="fa fa-compress"></i>
                                <span slot="title">{{
                                    $t(isDamageNotice ? 'Clients' : 'Micro Clients')
                                }}</span>
                            </el-menu-item>
                            <el-menu-item
                                index="/micro-list"
                                v-if="context.canRead('customer_management_micro_list')"
                            >
                                <i class="fa fa-compress"></i>
                                <span slot="title">{{
                                    $t(isDamageNotice ? 'Client Lists' : 'Micro List')
                                }}</span>
                            </el-menu-item>
                        </el-submenu>
                        <el-submenu index="2" v-if="context.canRead('claim_management')">
                            <template slot="title">
                                <i class="fa fa-bullseye"></i>
                                <span>{{ $t('Claim Management') }}</span>
                            </template>
                            <el-menu-item
                                index="/claim-dashboard"
                                v-if="context.canRead('claim_management_dashboard')"
                            >
                                <i class="fa fa-dashboard"></i>
                                <span slot="title">{{ $t('Dashboard') }}</span>
                            </el-menu-item>

                            <el-menu-item
                                index="/claim/new"
                                v-if="context.canCreate('claim_management')"
                            >
                                <i class="fa fa-dashboard"></i>
                                <span slot="title">{{ $t('Submit New Claim') }}</span>
                            </el-menu-item>
                            <el-menu-item
                                index="/claim-analytics"
                                v-if="context.canRead('claim_management_dashboard')"
                            >
                                <i class="fa fa-line-chart"></i>
                                <span slot="title">{{ $t('Analytics') }}</span>
                            </el-menu-item>
                        </el-submenu>
                        <el-menu-item
                            index="/appointments"
                            v-if="context.canRead('appointment_self', 'appointment_others')"
                        >
                            <i class="fa fa-calendar"></i>
                            <span slot="title">{{ $t('Call Agenda') }}</span>
                        </el-menu-item>
                        <el-menu-item
                            index="/conversations"
                            v-if="context.canRead('video_call_history')"
                        >
                            <i class="fa fa-camera-retro"></i>
                            <span slot="title">{{ $t('Call History') }}</span>
                        </el-menu-item>
                        <el-menu-item
                            index="/videocall"
                            v-if="
                                context.canCreate(
                                    'video_call_direct',
                                    'video_call_agent',
                                    'video_call_customer'
                                )
                            "
                        >
                            <i class="fa fa-camera-retro"></i>
                            <span slot="title">{{ $t('Set Call') }}</span>
                        </el-menu-item>
                        <el-menu-item
                            index="/sites"
                            v-if="isContextUserRootAdmin || context.canRead('sites')"
                        >
                            <i class="fa fa-cube"></i>
                            <span slot="title">{{ $t('Sites') }}</span>
                        </el-menu-item>
                        <el-menu-item index="/forms" v-if="isContextUserRootAdmin">
                            <i class="fa fa-file-text-o"></i>
                            <span slot="title">{{ $t('Forms Administration') }}</span>
                        </el-menu-item>
                        <el-menu-item index="/filemanager" v-if="isContextUserRootAdmin">
                            <i class="fa fa-file"></i>
                            <span slot="title">{{ $t('File Manager') }}</span>
                        </el-menu-item>
                        <el-menu-item index="/reports" v-if="context.canRead('reports_general')">
                            <i class="fa fa-line-chart"></i>
                            <span slot="title">{{ $t('Portfolio Analytics') }}</span>
                        </el-menu-item>
                        <el-menu-item
                            index="/adminreports"
                            v-if="context.canRead('org_admin_reports')"
                        >
                            <i class="fa fa-line-chart"></i>
                            <span slot="title">{{ $t('Admin Reports') }}</span>
                        </el-menu-item>
                        <el-menu-item
                            index="/auditlog"
                            v-if="context.canRead('organization_management_auditlog')"
                        >
                            <i class="fa fa-line-chart"></i>
                            <span slot="title">{{ $t('Audit Log') }}</span>
                        </el-menu-item>
                        <el-menu-item index="/translation" v-if="isContextUserRootAdmin">
                            <i class="fa fa-file-text-o"></i>
                            <span slot="title">{{ $t('Translation') }}</span>
                        </el-menu-item>
                    </el-menu>
                </el-scrollbar>
                <div class="profile-button-wrapper">
                    <div class="button-wrapper">
                        <el-popover
                            :open-delay="750"
                            :placement="$client.isMobile ? 'top' : 'right'"
                            width="230"
                            v-model="logoutConfirm"
                            popper-class="break-word"
                        >
                            <div class="mb-5px">{{ $t('Are you sure you want to logout?') }}</div>
                            <div class="text-align-right m-0">
                                <a @click="logout">
                                    <el-button type="primary" size="mini">{{
                                        $t('Yes')
                                    }}</el-button>
                                </a>
                                <el-button size="mini" type="text" @click="logoutConfirm = false">{{
                                    $t('Cancel')
                                }}</el-button>
                            </div>
                            <el-button
                                slot="reference"
                                class="text-decoration-underline"
                                type="text"
                                size="mini"
                            >
                                <i class="fa fa-sign-out"></i>
                                <span>{{ $t('Logout') }}</span>
                            </el-button>
                        </el-popover>
                        <span>|</span>
                        <el-dropdown trigger="click" class="user-info cursor-pointer">
                            <span class="text-white">
                                <span> {{ langLabel }} </span>
                                <i class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item
                                    v-for="item in $store.getters.getLangs"
                                    :key="item.languageCode"
                                    @click.native="languageCode = item.languageCode"
                                >
                                    <span> {{ item.label }} </span>
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                    <div class="seperator"></div>
                    <div class="copyright">{{ $t('Created by Virtual i Technologies') }}</div>
                </div>
            </div>
        </div>

        <usermodal
            v-if="modalVisible"
            v-model="modalVisible"
            :user="selectedUser"
            :organization="organization"
        ></usermodal>
    </el-aside>
</template>

<script>
import Organization from '@/data/Organization';
import usermodal from '../usermodal.vue';
import notifications from '../notifications.vue';

export default {
    name: 'sidenav',
    components: { usermodal, notifications },
    props: {
        isVisible: {
            type: Boolean,
            default() {
                return false;
            },
        },
    },
    data() {
        return {
            logoutConfirm: false,
            modalVisible: false,
            selectedUser: null,
            organization: new Organization(),
            languageCode: window.localStorage.language_code,
        };
    },
    computed: {
        langLabel() {
            return this.$store.getters.getLangs.filter((x) => x.languageCode === this.languageCode)
                .length > 0
                ? this.$store.getters.getLangs.filter(
                      (x) => x.languageCode === this.languageCode
                  )[0].label
                : '';
        },
        user() {
            return this.$store.getters.user;
        },
        context() {
            return this.$store.getters.context;
        },
        isAdmin() {
            return this.context.isAdmin;
        },
        isContextUserRootAdmin() {
            return this.$store.getters.isContextUserRootAdmin;
        },
        contextOrganization() {
            return this.context.organization;
        },
        isRtl() {
            return this.languageCode == 'ar';
        },
        isDamageNotice() {
            return this.$store.getters.isDamageNotice;
        },
    },
    watch: {
        $route() {
            this.$nextTick(() => {
                this.$refs.nav.activeIndex = this.$refs.nav.defaultActive;
                if (this.$client.width <= 900) {
                    this.$emit('menuClick');
                }
            });
        },
        languageCode(value) {
            window.localStorage.language_code = value;
            window.location.reload();
        },
    },
    methods: {
        async logout() {
            await this.$store.dispatch('signOut');
            window.location.href = '/';
        },
        onProfileClick() {
            this.selectedUser = this.user;
            this.organization.id = this.user.organization_id;
            this.modalVisible = true;
        },
        handleMenuSelect(key) {
            // Mobilde her durumda bütün ekranı
            // kaplayan drawerı route değişmediğinde de kapat.
            const routeunChanged = window.location.hash.slice(1) === key;
            if (routeunChanged && this.$client.isMobile) {
                this.$emit('menuClick');
            }
        },
    },
};
</script>

<style lang="scss">
@import '@/styles/responsive.scss';
aside.sidebar-container {
    height: 100%;
    overflow: hidden !important;
    width: 0px !important;
    left: -250px;
    background: var(--main-dark);
    transition: 0.5s;
    position: relative;
    &.expanded {
        left: 0px;
        width: 250px !important;

        @include sm {
            width: 100% !important;
        }
    }

    .profile-button-wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        color: var(--main-contrast);
        font-size: 16px;
        box-shadow: 0 1px 10px 7px var(--main-darker);

        @include sm {
            position: fixed;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 50px;
        }

        .button-wrapper {
            margin-bottom: 10px;
            margin-top: 10px;
            .el-button--text {
                color: var(--main-contrast);
            }
        }
    }

    .copyright {
        text-align: center;
        padding: 10px 0 10px;
        font-size: 14px;
        color: var(--main-watermark);
    }

    .profile-btn.text-primary {
        color: #008dd2 !important;
    }

    .sidenav {
        position: relative;
        height: calc(100% - 70px);

        .el-scrollbar {
            height: calc(100% - 228px);
            width: 100%;

            @include sm {
                height: calc(100% - 190px);
            }

            .el-scrollbar__wrap {
                overflow-x: hidden;
            }

            &.scrollbar-rtl {
                .el-scrollbar__wrap {
                    margin-left: -15px !important;
                    margin-bottom: -15px;
                }
            }
        }

        .sidenav-menu {
            border-right: 0px;

            .el-menu-item-group__title {
                font-size: 14px;
            }
            .el-menu-item,
            .el-submenu__title {
                background: transparent;
                color: var(--main-contrast);
                font-size: 16px;
                line-height: 40px;
                height: 40px;
                overflow: hidden;
                text-overflow: ellipsis;

                i {
                    width: 24px;
                    text-align: center;
                    color: var(--main-contrast);
                }
            }

            .el-submenu {
                .el-submenu__title {
                    line-height: 40px;
                    height: 40px;
                }
            }
        }
    }

    // BEGIN OF IMAGE COMPONENT AND AVATAR CSS
    .seperator {
        width: 100%;
        height: 1px;
        background-color: var(--main-transparent);
        margin: 0;
    }

    .header-wrapper {
        padding: 1rem;
        text-align: center;

        .seperator {
            margin: 1rem 0 !important;
        }
    }
    .logo-con {
        width: 100px;
        margin: auto;
    }

    .avatar {
        object-fit: cover;
        width: 65px;
        height: 65px;
        border-radius: 50%;
    }

    .user-name {
        font-size: 18px;
        color: white !important;
        cursor: pointer;
        &:hover {
            text-decoration: underline;
        }

        @include sm {
            margin-left: 1rem !important;
        }
    }
    // END OF IMAGE COMPONENT AND AVATAR CSS
}
</style>
